import React, { Component } from 'react'
import axios from 'axios'
import moment from 'moment'
import { Row, Col, Skeleton, Modal, message } from 'antd'
import { connect } from 'react-redux'
import { ButtonItem } from '../../../../Components/Items'
import DatePickerItem from '../../../../Components/DatePickerItem'
import { ExclamationCircleOutlined, CheckCircleOutlined, MinusOutlined } from '@ant-design/icons'

// ─── Helpers ──────────────────────────────────────────────────────────────────

const fmtMXN = (n) =>
  new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(n || 0)

const fmtFecha = (f) => {
  if (!f) return '—'
  const s = (f || '').split('T')[0]
  const p = s.split('-')
  return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : s
}

const TIPO_LABEL = {
  porcentaje:       'Porcentaje',
  factor_descuento: 'Factor de Descuento',
  cuota_fija:       'Cuota Fija',
}

function fmtFactor(tipoCredito, factor) {
  if (factor === null || factor === undefined || factor === '') return '—'
  const n = parseFloat(factor)
  if (isNaN(n)) return '—'
  if (tipoCredito === 'porcentaje')       return (n * 100).toFixed(2) + '%'
  if (tipoCredito === 'factor_descuento') return n.toFixed(4) + ' VSM'
  if (tipoCredito === 'cuota_fija')       return fmtMXN(n)
  return String(factor)
}

// ─── Estilos tabla ────────────────────────────────────────────────────────────

const TH = {
  border: '1px solid #d0d0d0', background: '#f5f5f5',
  padding: '5px 8px', fontSize: 11, fontWeight: 600,
  color: '#555', textAlign: 'center', whiteSpace: 'nowrap',
}
const TD = {
  border: '1px solid #e8e8e8', padding: '4px 8px',
  fontSize: 12, verticalAlign: 'middle',
}
const TD_NUM = { ...TD, textAlign: 'right', fontFamily: 'monospace' }

// ─── Estilos formulario ───────────────────────────────────────────────────────

const labelStyle  = { display: 'block', fontSize: 11, color: '#888', marginBottom: 3 }
const inputStyle  = { width: '100%', padding: '4px 8px', border: '1px solid #d0d0d0', borderRadius: 4, fontSize: 12, boxSizing: 'border-box' }
const selectStyle = { ...inputStyle, background: 'white', cursor: 'pointer', height: 28 }
const rowStyle    = { display: 'flex', gap: 12, marginBottom: 10 }

// ─────────────────────────────────────────────────────────────────────────────

class InfonvitEmpleado extends Component {

  state = {
    cargando:  false,
    error:     null,
    creditos:  [],
    // Formulario
    formVisible:           false,
    editandoId:            null,
    numeroCreditoInfonvit: '',
    descripcion:           '',
    tipoCredito:           'factor_descuento',
    factor:                '',
    incluirSeguro:         false,
    fechaAplicacion:       '',
    fechaSuspension:       '',
    montoAcumulado:        '',
    vecesAplicado:         '',
    montoCredito:          '',
    guardando:             false,
    // Historial
    historialVisible:      false,
    historialCredito:      null,
  }

  verHistorial(credito) {
    this.setState({ historialVisible: true, historialCredito: credito })
  }

  cerrarHistorial() {
    this.setState({ historialVisible: false, historialCredito: null })
  }

  renderModalHistorial() {
    const { historialVisible, historialCredito } = this.state
    const bitacora = historialCredito?.bitacoraAplicaciones || []

    return (
      <Modal
        title={`Historial — ${historialCredito?.numeroCreditoInfonvit || ''}`}
        visible={historialVisible}
        onCancel={() => this.cerrarHistorial()}
        footer={null}
        width={560}
      >
        <div style={{ overflowX: 'auto' }}>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={TH}>Fecha</th>
                <th style={{ ...TH, textAlign: 'right' }}>Importe Aplicado</th>
                <th style={{ ...TH, textAlign: 'right' }}>Acumulado</th>
                <th style={TH}>Liquidado</th>
              </tr>
            </thead>
            <tbody>
              {bitacora.length === 0 && (
                <tr>
                  <td colSpan={4} style={{ ...TD, textAlign: 'center', color: '#aaa', padding: 24 }}>
                    Sin movimientos registrados todavía
                  </td>
                </tr>
              )}
              {bitacora.map((mov, i) => (
                <tr key={i}>
                  <td style={TD}>{(mov.fecha + '').split('T')[0].split('-').reverse().join('/')}</td>
                  <td style={TD_NUM}>{fmtMXN(mov.importeAplicado)}</td>
                  <td style={TD_NUM}>{fmtMXN(mov.montoAcumuladoResultante)}</td>
                  <td style={{ ...TD, textAlign: 'center' }}>{mov.liquidado ? '✓' : ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal>
    )
  }

  componentDidMount() {
    this.cargarDatos()
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.empleadoId !== this.props.empleadoId ||
      prevProps.empresaId  !== this.props.empresaId
    ) {
      this.resetForm()
      this.cargarDatos()
    }
  }

  resetForm() {
    this.setState({
      formVisible: false, editandoId: null,
      numeroCreditoInfonvit: '', descripcion: '',
      tipoCredito: 'factor_descuento', factor: '',
      incluirSeguro: false, fechaAplicacion: '', fechaSuspension: '',
      montoAcumulado: '', vecesAplicado: '', montoCredito: '',
    })
  }

  // ── Fetch ──────────────────────────────────────────────────────────────────

  async cargarDatos() {
    const { empleadoId, empresaId, headersToken } = this.props
    if (!empleadoId || !empresaId) return
    this.setState({ cargando: true, error: null })
    try {
      const res = await axios.post(
        'nomina/creditosInfonvit',
        { empleadoId, empresaId },
        { headers: headersToken }
      )
      if (res.data.success === 2) {
        this.setState({ creditos: res.data.creditos || [] })
      } else {
        this.setState({ error: res.data.err || res.data.mensaje || 'Error al cargar créditos Infonavit' })
      }
    } catch {
      this.setState({ error: 'Error de conexión' })
    }
    this.setState({ cargando: false })
  }

  // ── Acciones ───────────────────────────────────────────────────────────────

  confirmarInactivar(creditoId) {
    Modal.confirm({
      title: '¿Inactivar este crédito Infonavit?',
      content: 'Ya no se aplicará en futuros períodos.',
      icon: <ExclamationCircleOutlined />,
      okText: 'Sí, inactivar',
      cancelText: 'No',
      onOk: () => this.inactivarCredito(creditoId),
    })
  }

  async inactivarCredito(creditoId) {
    const { empresaId, headersToken } = this.props
    try {
      const res = await axios.post(
        'nomina/cancelarCreditoInfonvit',
        { creditoId, empresaId },
        { headers: headersToken }
      )
      if (res.data.success === 2) {
        message.success('Crédito inactivado')
        this.cargarDatos()
        this.props.onCambio?.()
      } else {
        message.error(res.data.err || res.data.mensaje || 'Error al inactivar')
      }
    } catch {
      message.error('Error de conexión')
    }
  }

  abrirEdicion(credito) {
    this.setState({
      formVisible:           true,
      editandoId:            credito._id,
      numeroCreditoInfonvit: credito.numeroCreditoInfonvit || '',
      descripcion:           credito.descripcion || '',
      tipoCredito:           credito.tipoCredito || 'factor_descuento',
      factor:                credito.factor !== null && credito.factor !== undefined ? String(credito.factor) : '',
      incluirSeguro:         credito.incluirSeguro || false,
      fechaAplicacion:       (credito.fechaAplicacion  || '').split('T')[0],
      fechaSuspension:       (credito.fechaSuspension  || '').split('T')[0],
      montoCredito:          credito.montoCredito !== undefined ? String(credito.montoCredito) : '',
    })
  }

  abrirFormularioNuevo() {
    this.setState({
      formVisible: true, editandoId: null,
      numeroCreditoInfonvit: '', descripcion: '',
      tipoCredito: 'factor_descuento', factor: '',
      incluirSeguro: false, fechaAplicacion: '', fechaSuspension: '',
      montoAcumulado: '', vecesAplicado: '', montoCredito: '',
    })
  }

  async guardarCredito() {
    const { empleadoId, empresaId, headersToken } = this.props
    const {
      editandoId, numeroCreditoInfonvit, descripcion, tipoCredito,
      factor, incluirSeguro, fechaAplicacion, fechaSuspension,
      montoAcumulado, vecesAplicado, montoCredito,
    } = this.state

    if (!numeroCreditoInfonvit.trim()) { message.error('Ingresa el número de crédito Infonavit'); return }
    const factorNum = parseFloat(factor)
    if (factor === '' || isNaN(factorNum)) { message.error('Ingresa un valor numérico para el factor'); return }
    if (!fechaAplicacion) { message.error('Ingresa la fecha de aplicación'); return }

    const hoy = new Date().toISOString().split('T')[0]

    const body = {
      empleadoId, empresaId,
      numeroCreditoInfonvit: numeroCreditoInfonvit.trim(),
      descripcion:           descripcion.trim(),
      tipoCredito,
      factor:                factorNum,
      incluirSeguro,
      fechaAplicacion,
      fechaRegistro:         hoy,
      fechaSuspension:       fechaSuspension || null,
      montoCredito:          parseFloat(montoCredito) || 0,
    }
    if (editandoId) {
      body.creditoId = editandoId
    } else {
      body.montoAcumulado = parseFloat(montoAcumulado) || 0
      body.vecesAplicado  = parseInt(vecesAplicado, 10) || 0
    }

    this.setState({ guardando: true })
    try {
      const url = editandoId ? 'nomina/editarCreditoInfonvit' : 'nomina/crearCreditoInfonvit'
      const res = await axios.post(url, body, { headers: headersToken })
      if (res.data.success === 2) {
        message.success(editandoId ? 'Crédito actualizado' : 'Crédito creado')
        this.resetForm()
        this.cargarDatos()
        this.props.onCambio?.()
      } else {
        message.error(res.data.err || res.data.mensaje || 'Error al guardar')
      }
    } catch {
      message.error('Error de conexión')
    }
    this.setState({ guardando: false })
  }

  // ── Render parciales ───────────────────────────────────────────────────────

  renderNotaInformativa() {
    return (
      <div style={{
        background: '#fffbe6', border: '1px solid #ffe58f',
        borderRadius: 6, padding: '8px 14px', fontSize: 11,
        color: '#7c5a00', marginBottom: 12,
      }}>
        <b>Conceptos usados para INFONAVIT:</b>
        <span style={{ marginLeft: 8 }}>
          D-14. Seguro de vivienda Infonavit&nbsp;·&nbsp;
          D-15. Préstamo Infonavit (FD)&nbsp;·&nbsp;
          D-16. Préstamo Infonavit (CF)&nbsp;·&nbsp;
          D-59. Préstamo Infonavit (PORC)
        </span>
      </div>
    )
  }

  renderTabla() {
    const { creditos } = this.state
    const { timbrado } = this.props

    const btnStyle = (color) => ({
      fontSize: 11, padding: '2px 8px', borderRadius: 4,
      border: `1px solid ${color}`, cursor: 'pointer',
      background: 'white', color, marginRight: 4,
    })

    const colSpanBase = timbrado ? 10 : 11

    return (
      <div style={{ overflowX: 'auto', marginBottom: 12 }}>
        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
          <thead>
            <tr>
              <th style={TH}>Núm. Crédito</th>
              <th style={TH}>Descripción</th>
              <th style={TH}>Tipo</th>
              <th style={TH}>Factor</th>
              <th style={TH}>Seguro</th>
              <th style={{ ...TH, textAlign: 'right' }}>Monto Acum.</th>
              <th style={{ ...TH, textAlign: 'right' }}>Veces Aplic.</th>
              <th style={TH}>Fecha Aplicación</th>
              <th style={TH}>Fecha Suspensión</th>
              <th style={TH}>Estatus</th>
              {!timbrado && <th style={TH}>Acciones</th>}
            </tr>
          </thead>
          <tbody>
            {creditos.length === 0 && (
              <tr>
                <td colSpan={colSpanBase} style={{ ...TD, textAlign: 'center', color: '#aaa', padding: 24 }}>
                  Sin créditos Infonavit registrados
                </td>
              </tr>
            )}
            {creditos.map(credito => {
              const inactivo = credito.estatus === 0
              const tdBase = inactivo
                ? { ...TD, color: '#999', textDecoration: 'line-through', background: '#f5f5f5' }
                : TD
              const tdNum = inactivo
                ? { ...TD_NUM, color: '#999', textDecoration: 'line-through', background: '#f5f5f5' }
                : TD_NUM
              return (
                <tr key={credito._id}>
                  <td style={tdBase}>{credito.numeroCreditoInfonvit}</td>
                  <td style={tdBase}>{credito.descripcion || '—'}</td>
                  <td style={{ ...tdBase, textAlign: 'center' }}>
                    {TIPO_LABEL[credito.tipoCredito] || credito.tipoCredito}
                  </td>
                  <td style={{ ...tdNum }}>
                    {fmtFactor(credito.tipoCredito, credito.factor)}
                  </td>
                  <td style={{ ...tdBase, textAlign: 'center' }}>
                    {credito.incluirSeguro
                      ? <CheckCircleOutlined style={{ color: '#52c41a' }} />
                      : <MinusOutlined style={{ color: '#d9d9d9' }} />
                    }
                  </td>
                  <td style={tdNum}>{fmtMXN(credito.montoAcumulado)}</td>
                  <td style={tdNum}>{credito.vecesAplicado || 0}</td>
                  <td style={{ ...tdBase, textAlign: 'center' }}>{fmtFecha(credito.fechaAplicacion)}</td>
                  <td style={{ ...tdBase, textAlign: 'center' }}>{fmtFecha(credito.fechaSuspension)}</td>
                  <td style={{ ...TD, textAlign: 'center' }}>
                    {inactivo
                      ? <span style={{ background: '#f0f0f0', color: '#888', padding: '2px 8px', borderRadius: 4, fontSize: 11 }}>Inactivo</span>
                      : <span style={{ background: '#f6ffed', color: '#52c41a', padding: '2px 8px', borderRadius: 4, fontSize: 11, border: '1px solid #b7eb8f' }}>Activo</span>
                    }
                  </td>
                  {!timbrado && (
                    <td style={{ ...TD, textAlign: 'center', whiteSpace: 'nowrap' }}>
                      <button type="button" style={btnStyle('#555')} onClick={() => this.verHistorial(credito)}>Historial</button>
                      {!inactivo && (
                        <>
                          <button type="button" style={btnStyle('#1677ff')} onClick={() => this.abrirEdicion(credito)}>Editar</button>
                          <button type="button" style={btnStyle('#A32D2D')} onClick={() => this.confirmarInactivar(credito._id)}>Inactivar</button>
                        </>
                      )}
                    </td>
                  )}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }

  renderFormulario() {
    const {
      editandoId, numeroCreditoInfonvit, descripcion, tipoCredito,
      factor, incluirSeguro, fechaAplicacion, fechaSuspension, guardando,
      creditos, montoAcumulado, vecesAplicado, montoCredito,
    } = this.state

    const hoy = new Date().toISOString().split('T')[0]

    const factorLabel = {
      porcentaje:       'Porcentaje',
      factor_descuento: 'Factor de Descuento',
      cuota_fija:       'Cuota Fija Mensual',
    }[tipoCredito] || 'Factor'

    const factorPlaceholder = {
      porcentaje:       '0.25',
      factor_descuento: '1.5000',
      cuota_fija:       '0.00',
    }[tipoCredito] || ''

    const creditoEditando = editandoId
      ? creditos.find(c => c._id === editandoId)
      : null

    return (
      <div style={{ background: '#fafafa', border: '1px solid #e8e8e8', borderRadius: 6, padding: 16, marginTop: 12 }}>
        <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 12, color: '#333' }}>
          {editandoId ? 'Editar crédito Infonavit' : 'Nuevo crédito Infonavit'}
        </div>

        {/* a: Número + Descripción */}
        <div style={rowStyle}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Número de crédito Infonavit *</label>
            <input
              style={inputStyle}
              value={numeroCreditoInfonvit}
              onChange={e => this.setState({ numeroCreditoInfonvit: e.target.value })}
              placeholder="Número asignado por Infonavit"
            />
          </div>
          <div style={{ flex: 2 }}>
            <label style={labelStyle}>Descripción</label>
            <input
              style={inputStyle}
              value={descripcion}
              onChange={e => this.setState({ descripcion: e.target.value })}
              placeholder="Texto libre (opcional)"
            />
          </div>
        </div>

        {/* b: Tipo + Factor */}
        <div style={rowStyle}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Tipo de crédito *</label>
            <select
              style={selectStyle}
              value={tipoCredito}
              onChange={e => this.setState({ tipoCredito: e.target.value, factor: '' })}
            >
              <option value="porcentaje">Porcentaje</option>
              <option value="factor_descuento">Factor de Descuento</option>
              <option value="cuota_fija">Cuota Fija</option>
            </select>
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>{factorLabel} *</label>
            <input
              type="number"
              step="any"
              style={inputStyle}
              value={factor}
              onChange={e => this.setState({ factor: e.target.value })}
              placeholder={factorPlaceholder}
            />
          </div>
        </div>

        {/* c: Checkbox seguro */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
          <input
            type="checkbox"
            id="incluirSeguro"
            checked={incluirSeguro}
            onChange={e => this.setState({ incluirSeguro: e.target.checked })}
            style={{ cursor: 'pointer' }}
          />
          <label htmlFor="incluirSeguro" style={{ fontSize: 12, cursor: 'pointer', margin: 0 }}>
            Incluir pago de Seguro de vivienda (D-14)
          </label>
        </div>

        {/* d: Fechas */}
        <div style={rowStyle}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Fecha de aplicación *</label>
            <DatePickerItem
              style={{ ...inputStyle, width: '100%' }}
              value={fechaAplicacion ? moment(fechaAplicacion, 'YYYY-MM-DD') : null}
              onChange={(d) => this.setState({ fechaAplicacion: d ? d.format('YYYY-MM-DD') : '' })}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Fecha de registro</label>
            <div style={{ ...inputStyle, background: '#f5f5f5', color: '#888' }}>
              {fmtFecha(hoy)}
            </div>
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Fecha de suspensión (opcional)</label>
            <DatePickerItem
              style={{ ...inputStyle, width: '100%' }}
              value={fechaSuspension ? moment(fechaSuspension, 'YYYY-MM-DD') : null}
              onChange={(d) => this.setState({ fechaSuspension: d ? d.format('YYYY-MM-DD') : '' })}
            />
          </div>
        </div>

        {/* e: Monto acumulado y veces aplicado */}
        <div style={rowStyle}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>
              Monto acumulado{!editandoId ? ' (inicial)' : ''}
            </label>
            {editandoId && creditoEditando ? (
              <input
                style={{ ...inputStyle, background: '#f5f5f5', color: '#888' }}
                value={fmtMXN(creditoEditando.montoAcumulado)}
                readOnly
              />
            ) : (
              <input
                type="number"
                step="0.01"
                min="0"
                style={inputStyle}
                value={montoAcumulado}
                onChange={e => this.setState({ montoAcumulado: e.target.value })}
                placeholder="0.00"
              />
            )}
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>
              Veces aplicado{!editandoId ? ' (inicial)' : ''}
            </label>
            {editandoId && creditoEditando ? (
              <input
                style={{ ...inputStyle, background: '#f5f5f5', color: '#888' }}
                value={creditoEditando.vecesAplicado || 0}
                readOnly
              />
            ) : (
              <input
                type="number"
                step="1"
                min="0"
                style={inputStyle}
                value={vecesAplicado}
                onChange={e => this.setState({ vecesAplicado: e.target.value })}
                placeholder="0"
              />
            )}
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Monto del crédito (límite)</label>
            <input
              type="number"
              step="0.01"
              min="0"
              style={inputStyle}
              value={montoCredito}
              onChange={e => this.setState({ montoCredito: e.target.value })}
              placeholder="0.00"
            />
          </div>
        </div>

        {/* f: Botones */}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 4 }}>
          <button type="button"
            style={{ fontSize: 12, padding: '4px 14px', borderRadius: 4, border: '1px solid #d0d0d0', cursor: 'pointer', background: 'white' }}
            onClick={() => this.resetForm()}
            disabled={guardando}
          >
            Cancelar captura
          </button>
          <ButtonItem type="primary" size="small" loading={guardando} onClick={() => this.guardarCredito()}>
            Guardar
          </ButtonItem>
        </div>
      </div>
    )
  }

  render() {
    const { timbrado, readOnly } = this.props
    const { cargando, error, creditos, formVisible } = this.state

    const activos   = creditos.filter(c => c.estatus === 1).length
    const inactivos = creditos.filter(c => c.estatus === 0).length

    if (cargando && creditos.length === 0) {
      return <Skeleton active paragraph={{ rows: 4 }} />
    }

    return (
      <div>
        {timbrado && (
          <div style={{ marginBottom: 12, padding: '7px 14px', background: '#fffbe6', border: '1px solid #ffe58f', borderRadius: 6, fontSize: 12, color: '#7c5a00' }}>
            Nómina timbrada — visualización de solo lectura.
          </div>
        )}

        <Row gutter={12} style={{ marginBottom: 12 }}>
          <Col span={12}>
            <div style={{ background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 6, padding: '10px 14px' }}>
              <div style={{ fontSize: 11, color: '#52c41a' }}>Créditos activos</div>
              <div style={{ fontSize: 22, fontWeight: 700, color: '#52c41a' }}>{activos}</div>
            </div>
          </Col>
          <Col span={12}>
            <div style={{ background: '#f5f5f5', border: '1px solid #d9d9d9', borderRadius: 6, padding: '10px 14px' }}>
              <div style={{ fontSize: 11, color: '#888' }}>Créditos inactivos</div>
              <div style={{ fontSize: 22, fontWeight: 700, color: '#888' }}>{inactivos}</div>
            </div>
          </Col>
        </Row>

        {this.renderNotaInformativa()}

        {!timbrado && !readOnly && !formVisible && (
          <div style={{ marginBottom: 8, textAlign: 'right' }}>
            <ButtonItem size="small" onClick={() => this.abrirFormularioNuevo()}>
              + Agregar crédito
            </ButtonItem>
          </div>
        )}

        {error && (
          <div style={{ color: '#A32D2D', background: '#fff1f0', padding: '8px 12px', borderRadius: 4, marginBottom: 8, fontSize: 12 }}>
            {error}
          </div>
        )}

        {this.renderTabla()}
        {formVisible && this.renderFormulario()}
        {this.renderModalHistorial()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  headersToken: state.user.headersToken,
  empresaId:    state.empresa.id,
})

export default connect(mapStateToProps)(InfonvitEmpleado)
